import { Link } from "react-router-dom";
import { Navbar } from "../Navbar";
import { Footer } from "../Footer";

export const ListingNotFound = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 pt-24 pb-16">
        <div className="container px-4 mx-auto">
          <div className="text-center py-20">
            <h2 className="text-3xl font-bold mb-4">Listing Not Found</h2>
            <p className="text-muted-foreground">The listing you're looking for doesn't exist.</p>
            <Link
              to="/browse"
              className="text-sage-700 hover:text-sage-800 font-medium"
            >
              Back to Browse
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};
